import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * Legacy redirect: /admin/announcements → /admin/notifications (plan 112).
 * Permanent client-side redirect; old admin bookmarks resolve seamlessly.
 */
export const Route = createFileRoute("/$orgSlug/admin/announcements")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/$orgSlug/admin/notifications",
      params: { orgSlug: params.orgSlug },
      replace: true,
    });
  },
});
